import { render, staticRenderFns } from "./TrialsOne.vue?vue&type=template&id=533c5036&"
import script from "./TrialsOne.vue?vue&type=script&lang=js&"
export * from "./TrialsOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports